import { render } from "./AdminServiceTable.vue?vue&type=template&id=0bb13549&scoped=true"
import script from "./AdminServiceTable.vue?vue&type=script&lang=js"
export * from "./AdminServiceTable.vue?vue&type=script&lang=js"

import "./AdminServiceTable.vue?vue&type=style&index=0&id=0bb13549&scoped=true&lang=css"

import exportComponent from "/Users/yao/Documents/projects/garden/garden_ts/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bb13549"]])

export default __exports__